import React from "react";
import ME from "../../assets/banner.png";
import { FaWhmcs } from "react-icons/fa";
// import { FiUsers } from "react-icons/fi";
// import { VscFolderLibrary } from "react-icons/vsc";
import {FaAward } from "react-icons/fa";
import "./about.css";
const About = () => {
  return (
    <section className="about section" id="about">
      <h5>Get To Know</h5>
      <h2>About me</h2>
      <div className="about__container container grid">
        <div className="me">
          <img src={ME} alt="about imageunknow" className="about__img" />
        </div>
        <div className="about__data">
          <div className="about__cards grid">
            <article className="about__card">
              <FaWhmcs className="about__card-icon" />
              <h5>Experience</h5>
              <small>2+ Years Working</small>
            </article>
            {/* <article className="about__card">
              <FiUsers className="about__card-icon" />
              <h5>Clients</h5>
              <small>200+ Worldwide</small>
            </article> */}
            <article className="about__card">
              <FaAward className="about__card-icon" />
              <h5>Study Level</h5>
              <small>M.Sc</small>
            </article>
          </div>
          <p className="about__description">
            Hello, I am an aspiring researcher pursuing a master's degree in Telecommunications
            with a keen interest in RF and microwave design and simulation, IoT, and 
            programming. Learning is my secondary oxygen, essential for my growth 
            and vitality. With a solid foundation as an Electrical Engineer, I bring dedication,
            hard work, and proactive problem-solving to the table. 
            My experience spans across various domains, including design, simulation, 
            security, and safety enhancements. Proficient in MATLAB, I specialize in 
            optimizing processes to enhance operational efficiency. 
            I am on the lookout for an opportunity to channel my technical expertise 
            in a dynamic and challenging work environment, striving to make a 
            significant contribution as an invaluable asset to the organization I am a part of.
          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};
export default About;
